import { Component, OnInit, AfterViewInit, OnDestroy, inject } from '@angular/core';

import { Observable, Subscription, map } from 'rxjs';

import { LanguageService } from '@fcom/ui-translate';
import { PageMetaService } from '@fcom/common';
import { ConfigService } from '@fcom/core';
import { CmsTemplateService } from '@fcom/cms/services';
import { CmsTemplate } from '@fcom/core-api';
import { unsubscribe } from '@fcom/core/utils';

import { LoyaltyRoutesPath } from '../../interfaces/loyalty.interface';
import { setPageMetadata } from '../../utils';

@Component({
  selector: 'fin-loyalty-my-trips',
  templateUrl: './loyalty-my-trips.component.html',
  standalone: false,
})
export class LoyaltyMyTripsComponent implements OnInit, OnDestroy, AfterViewInit {
  private languageService = inject(LanguageService);
  private cmsTemplateService = inject(CmsTemplateService);
  private pageMetaService = inject(PageMetaService);
  private configService = inject(ConfigService);

  template$: Observable<CmsTemplate>;
  pageTitle$: Observable<string>;
  subscriptions: Subscription = new Subscription();
  enableShowingSAF: boolean;

  ngOnInit(): void {
    this.enableShowingSAF = this.configService.cfg.enableShowingSAF;

    this.template$ = this.cmsTemplateService.load(
      `/${this.languageService.langValue}/${LoyaltyRoutesPath.PLUS}/${LoyaltyRoutesPath.MY_TRIPS}`
    );
    this.pageTitle$ = this.template$.pipe(map((template: CmsTemplate) => template?.header?.[0]?.title ?? ''));
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(
      this.template$.subscribe((template: CmsTemplate) => setPageMetadata(template, this.pageMetaService))
    );
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }
}
